<template>
    <div class="main">
        <c-panel v-if="!status" title="CONFIGURAÇÕES DO SISTEMA" titleIcon="fas fa-sliders-h">
            <div class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <template v-else>
            <!-- ================= SEÇÃO 1: PARÂMETROS GLOBAIS ================= -->
            <el-tabs v-model="abaAtiva" type="border-card">
                <el-tab-pane v-for="cat in categorias" :key="cat.chave" :label="cat.label" :name="cat.chave">
                    <el-form label-position="top" @submit.native.prevent>
                        <div v-for="p in globaisPorCategoria(cat.chave)" :key="p.id" class="u-mt-15 u-mb-20" style="border-bottom: 1px solid #f0f0f0; padding-bottom: 12px;">
                            <el-form-item :label="p.chave">
                                <div v-if="p.descricao" style="color: #909399; font-size: 12px; margin-bottom: 6px;">{{ p.descricao }}</div>

                                <campos-obrigatorios-editor v-if="ehCamposObrigatorios(p)" :p="p" :valor="p.valor" @save="setValor(p, $event)"></campos-obrigatorios-editor>
                                <horarios-acesso-editor v-else-if="ehHorariosAcesso(p)" :p="p" :valor="p.valor" @save="setValor(p, $event)"></horarios-acesso-editor>
                                <avaliacao-select-editor v-else-if="ehAvaliacaoSelect(p)" :p="p" :valor="p.valor" @save="setValor(p, $event)"></avaliacao-select-editor>
                                <conceito-escala-editor v-else-if="ehConceitoEscala(p)" :p="p" :valor="p.valor" @save="setValor(p, $event)"></conceito-escala-editor>
                                <metodo-avaliacao-curso-editor v-else-if="ehMetodoAvaliacaoCurso(p)" :p="p" :valor="p.valor" @save="setValor(p, $event)"></metodo-avaliacao-curso-editor>
                                <param-control v-else :p="p" :valor="p.valor" @save="setValor(p, $event)"></param-control>

                                <div v-if="salvandoId === p.id" style="color: #409eff; font-size: 12px; margin-top: 4px;">
                                    <i class="el-icon-loading"></i> Salvando...
                                </div>
                                <div v-else-if="salvoId === p.id" style="color: #67c23a; font-size: 12px; margin-top: 4px;">
                                    <i class="el-icon-check"></i> Salvo
                                </div>
                            </el-form-item>
                        </div>

                        <div v-if="!globaisPorCategoria(cat.chave).length" class="u-text-center u-mt-25" style="color: #909399;">
                            Nenhum parâmetro nesta categoria.
                        </div>
                    </el-form>
                </el-tab-pane>

                <!-- ABA: RELATÓRIOS (logo por instituição) -->
                <el-tab-pane label="Relatórios" name="__relatorios">
                    <el-form label-position="top" @submit.native.prevent>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="16" :md="12">
                                <el-form-item label="Instituição">
                                    <el-select v-model="logoInstituicaoId" filterable clearable placeholder="Selecione a instituição" @change="carregarLogoInstituicao" style="width: 100%;">
                                        <el-option v-for="(item, i) in instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <div v-if="!logoInstituicaoId" style="border: 1px solid #eee; background: #fafafa; padding: 16px; text-align: center; color: #909399;">
                            Selecione uma instituição para gerenciar a logo dos relatórios.
                        </div>

                        <div v-else v-loading="carregandoLogo">
                            <p style="color: #909399; font-size: 12px;">
                                A logo enviada aqui é exibida nos relatórios ao lado da logo da prefeitura. Se a instituição não tiver logo cadastrada, apenas a logo da prefeitura é mostrada. Formatos aceitos: PNG ou JPEG, até 2MB.
                            </p>

                            <el-row :gutter="20">
                                <el-col :xs="24" :sm="12">
                                    <el-form-item label="Logo atual">
                                        <div v-if="logoPathAtual">
                                            <img :src="logoUrlAtual" style="max-width: 180px; max-height: 105px; border: 1px solid #eee; border-radius: 6px; padding: 6px;">
                                            <div class="u-mt-10">
                                                <el-button type="danger" plain size="small" @click="removerLogoRelatorio">REMOVER LOGO</el-button>
                                            </div>
                                        </div>
                                        <div v-else style="color: #909399;">Nenhuma logo cadastrada.</div>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12">
                                    <el-form-item label="Enviar nova logo" style="text-align: center;">
                                        <input-image v-model="logoFile" :maxBytes="2097152" @erro="onLogoErro"></input-image>
                                        <div class="u-mt-10">
                                            <el-button type="primary" size="small" :disabled="!logoFile || typeof logoFile === 'string'" :loading="salvandoLogo" @click="salvarLogoRelatorio">SALVAR LOGO</el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                </el-tab-pane>
            </el-tabs>

            <!-- ============= SEÇÃO 2: PARÂMETROS POR INSTITUIÇÃO ============= -->
            <c-panel v-if="parametrosInstituicao.length" title="PARÂMETROS POR INSTITUIÇÃO" titleIcon="fas fa-school" class="u-mt-20">
                <el-form label-position="top" @submit.native.prevent>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Instituição">
                                <el-select v-model="instituicaoId" filterable clearable placeholder="Selecione a instituição" @change="onInstituicaoChange">
                                    <el-option v-for="(item, i) in instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <div v-if="!instituicaoId" style="border: 1px solid #eee; background: #fafafa; padding: 16px; text-align: center; color: #909399;">
                    Selecione uma instituição.
                </div>

                <el-form v-else label-position="top" @submit.native.prevent>
                    <div v-for="p in parametrosInstituicao" :key="p.id" class="u-mt-15 u-mb-20" style="border-bottom: 1px solid #f0f0f0; padding-bottom: 12px;">
                        <el-form-item :label="p.chave">
                            <div v-if="p.descricao" style="color: #909399; font-size: 12px; margin-bottom: 6px;">{{ p.descricao }}</div>

                            <param-control :p="p" :valor="valorAtual(p)" @save="setValor(p, $event)"></param-control>

                            <div v-if="salvandoId === p.id" style="color: #409eff; font-size: 12px; margin-top: 4px;">
                                <i class="el-icon-loading"></i> Salvando...
                            </div>
                            <div v-else-if="salvoId === p.id" style="color: #67c23a; font-size: 12px; margin-top: 4px;">
                                <i class="el-icon-check"></i> Salvo
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
            </c-panel>
        </template>
    </div>
</template>

<script>
import ParamControl from './param-control.vue'
import CamposObrigatoriosEditor from './campos-obrigatorios-editor.vue'
import HorariosAcessoEditor from './horarios-acesso-editor.vue'
import AvaliacaoSelectEditor from './avaliacao-select-editor.vue'
import ConceitoEscalaEditor from './conceito-escala-editor.vue'
import MetodoAvaliacaoCursoEditor from './metodo-avaliacao-curso-editor.vue'
import InputImage from '@/shared/input-image/input-image.vue'
import { CHAVE_CAMPOS_ALUNO, CHAVE_CAMPOS_SERVIDOR } from '@/shared/constants/camposObrigatorios'
import { CHAVE_HORARIOS_ACESSO } from '@/shared/constants/permissoesModulo'
import { CHAVE_AVALIACAO_METODO, CHAVE_AVALIACAO_CONCEITO_MODO, CHAVE_AVALIACAO_CONCEITO_ID, CHAVE_AVALIACAO_CONCEITO_GRANULARIDADE, CHAVE_DIARIO_FREQUENCIA_MODO, CHAVE_DIARIO_NOTA_MODO, CHAVE_DIARIO_METODO_AVALIACAO_POR_CURSO } from '@/shared/constants/avaliacaoConceito'

const ROTULOS_CATEGORIA = [
    { chave: 'aluno',       label: 'Aluno' },
    { chave: 'professor',   label: 'Professor' },
    { chave: 'upload',      label: 'Upload' },
    { chave: 'acesso',      label: 'Acesso' },
    { chave: 'avaliacao',   label: 'Avaliação' },
    { chave: 'diario',      label: 'Diário' },
]

// Chaves cujo valor é definido POR INSTITUIÇÃO (usam o seletor de instituição desta tela).
// As demais chaves do catálogo são globais.
const PARAMETROS_POR_INSTITUICAO = [
    'aluno.permite_acentuacao',
    'servidor.permite_acentuacao'
]

export default {
    components: { ParamControl, CamposObrigatoriosEditor, HorariosAcessoEditor, AvaliacaoSelectEditor, ConceitoEscalaEditor, MetodoAvaliacaoCursoEditor, InputImage },
    data: () => ({
        status: false,
        parametros: [],
        categorias: ROTULOS_CATEGORIA,
        abaAtiva: 'aluno',
        salvandoId: null,
        salvoId: null,
        instituicaoId: '',
        valoresInst: {},   // valor por instituição das chaves "Por instituição", chaveado por p.chave
        // Aba Relatórios (logo por instituição)
        logoInstituicaoId: '',
        carregandoLogo: false,
        logoPathAtual: '',
        logoFile: '',
        salvandoLogo: false,
        logoCacheBuster: 0
    }),
    computed: {
        instituicoes () {
            return this.$store.state.instituicoes || []
        },
        parametrosInstituicao () {
            return this.parametros.filter(p => this.ehPorInstituicao(p))
        },
        logoUrlAtual () {
            if (!this.logoPathAtual) return ''
            return `${this.$store.state.config.baseUrlApi}/storage/${this.logoPathAtual}?t=${this.logoCacheBuster}`
        }
    },
    mounted () { this.load() },
    methods: {
        carregarLogoInstituicao () {
            this.logoFile = ''
            this.logoPathAtual = ''
            if (!this.logoInstituicaoId) return
            this.carregandoLogo = true
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao-personalizacao/get/${this.logoInstituicaoId}`, this.$store.getters.getHeaderAuth).then(r => {
                this.carregandoLogo = false
                this.logoPathAtual = (r.data && r.data.logo && r.data.logo.path) ? r.data.logo.path : ''
                this.logoCacheBuster = Date.now()
            }).catch(e => { this.carregandoLogo = false; this.$store.commit('throwException', e) })
        },
        onLogoErro (msg) {
            if (msg) window.eventBus.$emit('alert', { msg, type: 'warning' })
        },
        salvarLogoRelatorio () {
            if (!this.logoFile || typeof this.logoFile === 'string') {
                window.eventBus.$emit('alert', { msg: 'Selecione uma imagem.', type: 'warning' })
                return
            }
            const fd = new FormData()
            fd.append('logo', this.logoFile)
            this.salvandoLogo = true
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao-personalizacao/uploadLogo/${this.logoInstituicaoId}`, fd, this.$store.getters.getHeaderFileAuth).then(r => {
                this.salvandoLogo = false
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Logo salva com sucesso.', type: 'success' })
                this.logoFile = ''
                this.carregarLogoInstituicao()
            }).catch(e => { this.salvandoLogo = false; this.$store.commit('throwException', e) })
        },
        removerLogoRelatorio () {
            this.$msgbox.confirm('Deseja remover a logo desta instituição?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/instituicao-personalizacao/removerLogo/${this.logoInstituicaoId}`, this.$store.getters.getHeaderAuth).then(() => {
                    window.eventBus.$emit('alert', { msg: 'Logo removida.', type: 'success' })
                    this.logoPathAtual = ''
                    this.logoFile = ''
                }).catch(e => { this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        load () {
            this.status = false
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.parametros = r.data || []
                this.status = true
            }).catch(e => {
                this.status = true
                this.$store.commit('throwException', e)
            })
        },
        globaisPorCategoria (cat) {
            return this.parametros.filter(p => p.categoria === cat && !this.ehPorInstituicao(p))
        },
        ehCamposObrigatorios (p) {
            return p.chave === CHAVE_CAMPOS_ALUNO || p.chave === CHAVE_CAMPOS_SERVIDOR
        },
        ehHorariosAcesso (p) {
            return p.chave === CHAVE_HORARIOS_ACESSO
        },
        ehAvaliacaoSelect (p) {
            return p.chave === CHAVE_AVALIACAO_METODO || p.chave === CHAVE_AVALIACAO_CONCEITO_MODO || p.chave === CHAVE_AVALIACAO_CONCEITO_GRANULARIDADE || p.chave === CHAVE_DIARIO_FREQUENCIA_MODO || p.chave === CHAVE_DIARIO_NOTA_MODO
        },
        ehConceitoEscala (p) {
            return p.chave === CHAVE_AVALIACAO_CONCEITO_ID
        },
        ehMetodoAvaliacaoCurso (p) {
            return p.chave === CHAVE_DIARIO_METODO_AVALIACAO_POR_CURSO
        },

        // ----------------- escopo por instituição -----------------
        ehPorInstituicao (p) {
            return PARAMETROS_POR_INSTITUICAO.includes(p.chave)
        },
        bloqueado (p) {
            return this.ehPorInstituicao(p) && !this.instituicaoId
        },
        valorAtual (p) {
            // Chaves por instituição (com instituição selecionada) usam o valor da instituição,
            // com fallback ao global feito pelo backend. As demais usam o valor global.
            if (this.ehPorInstituicao(p) && this.instituicaoId && this.valoresInst[p.chave] !== undefined) {
                return this.valoresInst[p.chave]
            }
            return p.valor
        },
        onInstituicaoChange () {
            this.valoresInst = {}
            if (!this.instituicaoId) return

            const base = this.$store.state.config.baseUrlApi
            const auth = this.$store.getters.getHeaderAuth
            const inst = this.instituicaoId

            PARAMETROS_POR_INSTITUICAO.forEach(chave => {
                if (!this.parametros.some(p => p.chave === chave)) return
                this.$axios.get(`${base}/api/parametro-sistema/getValor/${chave}?instituicao_id=${inst}`, auth)
                    .then(r => { this.$set(this.valoresInst, chave, (r.data && r.data.valor !== undefined) ? r.data.valor : '') })
                    .catch(e => { this.$store.commit('throwException', e) })
            })
        },

        // ----------------- persistência -----------------
        serializarLocal (novoValor) {
            if (typeof novoValor === 'object' && novoValor !== null) return JSON.stringify(novoValor)
            if (novoValor === true) return '1'
            if (novoValor === false) return '0'
            return String(novoValor)
        },
        setValor (p, novoValor) {
            if (this.bloqueado(p)) return

            const porInst = this.ehPorInstituicao(p) && this.instituicaoId
            const instId = porInst ? this.instituicaoId : null

            this.salvandoId = p.id
            this.salvoId = null
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/parametro-sistema/set`,
                { chave: p.chave, valor: novoValor, instituicao_id: instId },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.salvandoId = null
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                const valorSerializado = this.serializarLocal(novoValor)
                if (porInst) {
                    this.$set(this.valoresInst, p.chave, valorSerializado)
                } else {
                    p.valor = valorSerializado
                }
                this.salvoId = p.id
                setTimeout(() => { if (this.salvoId === p.id) this.salvoId = null }, 2000)
            }).catch(e => {
                this.salvandoId = null
                this.$store.commit('throwException', e)
            })
        }
    }
}
</script>
